// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y_df_","title":"styles_title__LhjDn"};